"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const useNotifiConfig_1 = __importDefault(require("./useNotifiConfig"));
const notifi_axios_adapter_1 = require("@notifi-network/notifi-axios-adapter");
const react_1 = require("react");
const useNotifiService = (env) => {
    const { gqlUrl } = (0, useNotifiConfig_1.default)(env);
    const service = (0, react_1.useMemo)(() => {
        const config = {
            gqlUrl,
        };
        return new notifi_axios_adapter_1.NotifiAxiosService(config);
    }, [gqlUrl]);
    return service;
};
exports.default = useNotifiService;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlTm90aWZpU2VydmljZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2xpYi9ob29rcy91c2VOb3RpZmlTZXJ2aWNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsd0VBQWdEO0FBQ2hELCtFQUEwRTtBQUUxRSxpQ0FBZ0M7QUFFaEMsTUFBTSxnQkFBZ0IsR0FBRyxDQUN2QixHQUEwQyxFQUMzQixFQUFFO0lBQ2pCLE1BQU0sRUFBRSxNQUFNLEVBQUUsR0FBRyxJQUFBLHlCQUFlLEVBQUMsR0FBRyxDQUFDLENBQUM7SUFFeEMsTUFBTSxPQUFPLEdBQUcsSUFBQSxlQUFPLEVBQUMsR0FBRyxFQUFFO1FBQzNCLE1BQU0sTUFBTSxHQUFHO1lBQ2IsTUFBTTtTQUNQLENBQUM7UUFDRixPQUFPLElBQUkseUNBQWtCLENBQUMsTUFBTSxDQUFDLENBQUM7SUFDeEMsQ0FBQyxFQUFFLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQztJQUViLE9BQU8sT0FBTyxDQUFDO0FBQ2pCLENBQUMsQ0FBQztBQUVGLGtCQUFlLGdCQUFnQixDQUFDIn0=